module.exports = __webpack_public_path__ + "img/2016-2.0a7865e0.jpeg";